import { useContextCheckoutData } from "@/Context/Checkout/ContextCheckoutProvider";
import { formatMX } from "@/Utils/Fomat.price";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTicketCart } from "@/Hooks/TicketCart/useTicketCart";
import { useAddToCardBuy } from "@/Service/Api/Index";
import type { BuyProduct } from "@/Models/MBuyPropduct/BuyProduct";
import "./PurcharsSummary.css";

type propsRecibo = {
  HeaddleSendBuy: (sendBuyAc: boolean) => void;
};

const PurcharsSummary = ({ HeaddleSendBuy }: propsRecibo) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { taskCart, ViewSubTotal } = useContextCheckoutData();
  const { addTicketProduct } = useTicketCart();

  const { postData, buyCardSku } = useAddToCardBuy();
  const navigate = useNavigate();

  const CreateBasketOrderBuy = async () => {
    setIsLoading(true);

    //actualizamos el estado del boton.
    const OrderBuyBasket: BuyProduct = {
      skuId:
        addTicketProduct
          .flatMap((x) => x.item_id)
          .filter(Boolean)
          .join(",") ?? "",
      productItems: addTicketProduct,
    };

    await postData(buyCardSku, OrderBuyBasket).finally(() =>
      setIsLoading(false)
    );

    if (!isLoading) {
      HeaddleSendBuy(true);
      navigate(
        `/Electrónicav2/articles/c/Checkout/FinshBuy?viewCart=sendshoppingcart.html`
      );
    }
  };

  return (
    <div className="row">
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <div className="ps-block--shopping-total">
          <div className="ps-block__header">
            <p>
              Subtotal <span> ${ViewSubTotal}</span>
            </p>
          </div>
          <div className="ps-block__content">
            <ul
              className={`ps-block__product 
                ${taskCart.length > 3 ? "scrollBuyer" : ""}
              `}>
              {taskCart &&
                taskCart.map((c) => (
                  <li key={c.IdSKU}>
                    <span className="ps-block__shop">
                      Articulo : <Link to={""}>{c.TitleProduct}</Link>
                    </span>
                    <span className="ps-block__shipping">
                      Precio {"  "}: $ {formatMX(c.PriceProduct)}
                    </span>
                    <span className="ps-block__shipping">
                      Cantidad : x{c.Quantity}
                    </span>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div className="ps-block--shopping-total">
          <div className="ps-block__content">
            <h3>
              Total <span>${ViewSubTotal}</span>
            </h3>
          </div>
        </div>
        <div className="d-flex justify-content-center w-100">
          <button
            //className={`ps-btn ps-btn--fullwidth text-white mb-3 ${
            className={`ps-btn develop__buttons btn__develop__movil text-white mb-3 ${
              isLoading
                ? "progress-bar progress-bar-striped progress-bar-animated bg-danger"
                : ""
            }`}
            onClick={CreateBasketOrderBuy}
            disabled={isLoading}>
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-md"
                  role="status"
                  aria-hidden="true"></span>
                <span className="ml-4">Procesando ... </span>
              </>
            ) : (
              "Procesar la compra"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PurcharsSummary;
